// Кэш запросов пульта (задача D4): TanStack Query 5.
//
// - Данные свежие 30 с; при возврате на вкладку — перезапрос (Review Focus 3: вкладка открыта с утра).
// - Повтор запроса — один раз и только при «Сервис Анны не отвечает»: на ошибку сервера повтор не поможет, а на
//   ответ не по контракту — тем более. Изменения (мутации) не повторяются никогда: второе «Остановить» или «Принять»
//   не должно уйти само.
// - При ошибке прежние данные остаются (так TanStack Query устроен по умолчанию): экран показывает их с пометкой.
// - `networkMode: 'always'`: запрос уходит, даже если браузер считает, что сети нет. Связь пульт отмечает сам
//   (`connection.ts`), а запрос «на паузе» ничего бы не отметил — и баннер «Нет связи» молчал бы. Изменение
//   в режиме по умолчанию ждало бы сети и ушло бы позже, когда человек уже забыл о нём.
import { QueryClient } from '@tanstack/react-query';
import { ServiceUnavailableError } from './errors';

/** Повторить ли запрос после `failureCount` неудач (0 — после первой). */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  return failureCount < 1 && error instanceof ServiceUnavailableError;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: shouldRetryQuery,
        networkMode: 'always',
      },
      mutations: {
        retry: false,
        networkMode: 'always',
      },
    },
  });
}
